import { BodyText, HeaderText, Separator } from "@/components/ui";
import { formatDateTime } from "@/lib/time";
import { MedicationRequest } from "@curai/js-fhir-tools";
import { FailedPrescriptionCallout } from "./FailedPrescriptionCallout";
import { type Detail, usePrescriptionInfo } from "./usePrescriptionInfo";

export const PrescriptionInfo = ({
  medicationRequest,
}: {
  medicationRequest: MedicationRequest;
}) => {
  const { rxDetailsGroup1, rxDetailsGroup2, rxDetailsGroup3 } =
    usePrescriptionInfo(medicationRequest);

  const rxFillStatus = medicationRequest.rxFillStatus;
  const rxFillStatusLabel = medicationRequest.rxFillStatusLabel;

  return (
    <div className="flex flex-col gap-4">
      {medicationRequest.dosespotStatus ===
        MedicationRequest.DOSESPOT_STATUS.values.ERROR && (
        <FailedPrescriptionCallout medicationRequest={medicationRequest} />
      )}
      <div className="grid grid-cols-2 gap-4">
        {rxDetailsGroup1.map((detail: Detail) => (
          <div key={detail.label} className="flex flex-1 flex-col gap-1">
            <HeaderText size="sm">{detail.label}</HeaderText>
            <BodyText size="sm">{detail.value}</BodyText>
          </div>
        ))}
      </div>
      <Separator />
      <div className="grid grid-cols-2 gap-4">
        {rxDetailsGroup2.map((detail) => (
          <div key={detail.label} className="flex flex-1 flex-col gap-1">
            <HeaderText size="sm">{detail.label}</HeaderText>
            <BodyText size="sm" preserveLineBreaks>
              {detail.value}
            </BodyText>
          </div>
        ))}
      </div>
      <Separator />
      <div className="grid grid-cols-2 gap-4">
        {rxDetailsGroup3.map((detail) => (
          <div key={detail.label} className="flex flex-1 flex-col gap-1">
            <HeaderText size="sm">{detail.label}</HeaderText>
            <BodyText size="sm">{detail.value}</BodyText>
          </div>
        ))}
        {rxFillStatus && (
          <div className="col-span-2 flex flex-1 flex-col gap-1">
            <HeaderText size="sm">Fill Status</HeaderText>
            <BodyText size="sm">
              {rxFillStatusLabel ?? rxFillStatus.status}
              {rxFillStatus.occurred
                ? ` on ${formatDateTime(rxFillStatus.occurred)}`
                : null}
            </BodyText>
            {rxFillStatus.notes && (
              <BodyText size="sm" textColor="tertiary" italic>
                {`Note from Pharmacy: ${rxFillStatus.notes}`}
              </BodyText>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
